import {
  CustomConditionModel,
  SpecialConditionData,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client'

const withUpdatedCustomConditionDueDate = (
  customCondition: CustomConditionModel,
  clauseId: string,
  newDueDate: string | undefined
): CustomConditionModel => {
  if (customCondition.clauseId === clauseId) {
    return {
      ...customCondition,
      overriddenDueDate: newDueDate
        ? {
            referenceDate: newDueDate,
          }
        : undefined,
    }
  }

  return {
    ...customCondition,
    subClauses: customCondition.subClauses?.map((subClause) =>
      withUpdatedCustomConditionDueDate(subClause, clauseId, newDueDate)
    ),
  }
}

export const withUpdatedSpecialConditionDueDate = (
  condition: SpecialConditionData,
  clauseId: string,
  newDueDate: string | undefined
): SpecialConditionData => {
  if (condition.conditionType === SpecialConditionDataConditionType.Custom) {
    return {
      ...condition,
      customCondition: condition.customCondition
        ? withUpdatedCustomConditionDueDate(
            condition.customCondition,
            clauseId,
            newDueDate
          )
        : undefined,
    }
  }

  return {
    ...condition,
    clauses: condition.clauses?.map((clause) => {
      if (clause.clauseId !== clauseId) return clause

      return {
        ...clause,
        overriddenDueDate: newDueDate
          ? {
              referenceDate: newDueDate,
            }
          : undefined,
      }
    }),
  }
}
